export const initialServiceItemFormData = {
  service_item_id: '' as any,
  reg_payroll_item: null as any,
  overtime_payroll_item: null as any,
  double_overtime_payroll_item: null as any,
  billable: [] as any,
};
